import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import "./style.scss";
import { useParams } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { Helmet } from "react-helmet";
import ReportCard from "./reportCard";
import { WidgetFooter, WidgetHeader } from "../../widgets";
import { FETCH_REPORT } from "../../store/Report/Report.constant";
import AnimatedLoader from "../../modules/ui/animatedLoader";
import ModalEditProfile from "../../modules/ui/Modals/ModalEditProfile";
import ModalSetting from "../../modules/ui/Modals/ModalSetting";
import {
  CLOSE_MODAL_AUTH,
  MODAL_TOGGLE,
  NEW_USER_MODAL,
} from "../../store/Modal/Modal.constant";
import ModalAuth from "../../modules/ui/Modals/ModalAuth";
import ModalConfirmation from "../../modules/ui/Modals/ModalСonfirmation";
import ModalGroupSetting from "../../modules/ui/Modals/ModalGroupSettings";

const Report = () => {
  const dispatch = useDispatch();
  const token = localStorage.getItem("token");
  const { slug_uuid } = useParams();
  const [currentPage, setCurrentPage] = useState(1);
  const common = useSelector((state) => state.common);
  const { report, isLoading } = useSelector((state) => state.reportInformation);
  const modals = useSelector((store) => store.modal[slug_uuid]);
  const form = useSelector((state) => state.form);
  const { user_group_orders } = report || {};
  const groupOrders = common.groupOrders?.[slug_uuid];
  const isJoin = true;
  const settings = common.settings?.[slug_uuid];
  const [filters, setFilters] = useState(null);
  const [tempFilters, setTempFilters] = useState(null);
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setTempFilters((prevFilters) => ({
      ...prevFilters,
      [name]: value,
    }));
  };
  const handleClearFilter = () => {
    setFilters({
      startDate: "",
      endDate: "",
      company: "",
    });
    setTempFilters({
      startDate: "",
      endDate: "",
      company: "",
    });
    setCurrentPage(1);
  };
  const fetchData = () => {
    dispatch({
      type: FETCH_REPORT,
      payload: filters
        ? {
          page: currentPage,
          ...Object.fromEntries(
            Object.entries(filters).filter(([_, value]) => value !== "")
          ),
        }
        : { page: currentPage },
    });
  };
  const handleButtonClick = () => {
    const { startDate, endDate, company } = tempFilters || {};
    if ((!startDate || !endDate) && !company) {
      console.warn(
        "Either both startDate and endDate must be present, or company must be provided."
      );
      return;
    }
    if (JSON.stringify(tempFilters) == JSON.stringify(filters)) {
      fetchData();
    } else if (JSON.stringify(tempFilters) !== JSON.stringify(filters)) {
      setCurrentPage(1);
    }
    setFilters(tempFilters);
  };

  useEffect(() => {
    if (token) {
      fetchData();
    }
  }, [currentPage, token, filters]);
  useEffect(() => {
    if (settings?.auth?.auth_token !== token) {
      dispatch({ type: NEW_USER_MODAL, payload: slug_uuid });
    }
  }, []);
  return (
    <>
      <AnimatedLoader isLoading={isLoading} />
      <WidgetHeader
        user_id={slug_uuid}
        isJoin={isJoin}
        auth={settings?.auth}
        creator_id={slug_uuid}
      />
      <Helmet>
        <meta charSet="utf-8" />
        <title>Reports</title>
        <meta id="meta-description" name="description" content={"njjn"} />
      </Helmet>
      {modals?.isModalAuth ? (
        <ModalAuth
          user_id={slug_uuid}
          error={form.form?.error?.message}
          show={modals.isModalAuth}
          onHide={() =>
            dispatch({ type: CLOSE_MODAL_AUTH, payload: slug_uuid })
          }
        />
      ) : null}
      <ToastContainer progressClassName="fancy-progress-bar" />
      {modals?.isModalConfirmation ? (
        <ModalConfirmation
          user_id={slug_uuid}
          isResendCode={settings?.isResendCode}
          error={form.form?.error?.message}
          show={modals.isModalConfirmation}
          order_deadline={groupOrders?.order_deadline * 1000}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalConfirmation", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalEditProfile ? (
        <ModalEditProfile
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalEditProfile}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalEditProfile", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalSetting ? (
        <ModalSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      {modals?.isModalGroupSetting ? (
        <ModalGroupSetting
          error={form.form?.error?.message}
          user_id={slug_uuid}
          groupOrders={groupOrders}
          show={modals.isModalGroupSetting}
          auth={settings?.auth}
          onHide={() =>
            dispatch({
              type: MODAL_TOGGLE,
              payload: { data: "isModalGroupSetting", user_id: slug_uuid },
            })
          }
        />
      ) : null}
      <div className="report-container">
        <h2 className="report-title">Report Overview</h2>
        <div className="report-card">
          <div className="filters">
            <div className="filter-group">
              <label>Delivery Start Date</label>
              <input
                type="date"
                name="startDate"
                placeholder="Select Start Date"
                style={{ cursor: "pointer" }}
                value={tempFilters?.startDate}
                onChange={handleInputChange}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
            </div>
            <div className="filter-group">
              <label>Delivery End Date</label>
              <input
                type="date"
                name="endDate"
                placeholder="Select End Date"
                style={{ cursor: "pointer" }}
                value={tempFilters?.endDate}
                onChange={handleInputChange}
                onClick={(e) => e.target.showPicker && e.target.showPicker()}
              />
            </div>
            <div className="filter-group">
              <label>Search by Vendor Name</label>
              <input
                type="text"
                name="company"
                placeholder="Enter Vendor Name"
                value={tempFilters?.company}
                onChange={handleInputChange}
              />
            </div>
            {/* Styled button inside filters div */}
            <button className="submit-button" onClick={handleButtonClick}>
              Submit
            </button>
            <button className="remove-filter" onClick={handleClearFilter}>
              Clear
            </button>
          </div>
          {isLoading ? (
            <div className="report-text">Fetching reports...</div>
          ) : user_group_orders?.length > 0 ? (
            <ReportCard
              setCurrentPage={setCurrentPage}
              currentPage={currentPage}
              data={report}
            />
          ) : (
            <div className="report-text">No results available.</div>
          )}
        </div>
      </div>
      <WidgetFooter />
    </>
  );
};

export default Report;
